export default {
  title: 'Opret onboarding-link',
  steps: {
    select_gateway: 'Vælg gateway',
    copy_link: 'Kopiér link',
  },
  select_gateway: {
    description: 'Vælg den betalingsgateway, du vil generere et langtidsholdbart onboarding-link til.',
  },
  link: {
    proxy_url_label: 'Onboarding-URL',
    expires_label: 'Udløber',
    copy_button: 'Kopiér URL',
    copied: 'Kopieret!',
    description:
      'Del denne URL med forhandleren. Den videresender til betalingsgatewayens onboarding-side og er gyldig indtil udløbsdatoen.',
  },
  buttons: {
    next: 'Næste',
    back: 'Tilbage',
    done: 'Færdig',
  },
  toasts: {
    create_success: 'Onboarding-linket blev oprettet.',
    create_failed: 'Onboarding-linket kunne ikke oprettes.',
  },
};
